import {
    REPORTS_HARVEST_INSPECTIONS_ALL_LOAD_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_ALL_LOAD_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_ALL_LOAD_FAILED,
    REPORTS_HARVEST_INSPECTIONS_ALL_POLLING_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_ALL_POLLING_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_ALL_POLLING_FAILED,
    REPORTS_HARVEST_INSPECTIONS_ALL_POLLING_CANCELED,
    REPORTS_HARVEST_INSPECTIONS_ALL_EXPORT_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_ALL_EXPORT_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_ALL_EXPORT_FAILED,
    REPORTS_HARVEST_INSPECTIONS_ALL_SET,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGE,
    REPORTS_HARVEST_INSPECTION_SET
} from './constants';

export function requestloadReportsHarvestInspectionsAll() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_LOAD_REQUESTED
    };
}

export function succeededLoadReportsHarvestInspectionsAll(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadReportsHarvestInspectionsAll(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestPollingReportsHarvestInspectionsAll() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_POLLING_REQUESTED
    };
}

export function succeededPollingReportsHarvestInspectionsAll(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_POLLING_SUCCEEDED,
        payload: response
    };
}

export function failedPollingReportsHarvestInspectionsAll(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_POLLING_FAILED,
        payload: error,
        error: true
    };
}

export function canceledPollingReportsHarvestInspectionsAll() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_POLLING_CANCELED
    };
}

export function requestExportReportsHarvestInspectionsAll() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_EXPORT_REQUESTED
    };
}

export function succeededExportReportsHarvestInspectionsAll(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_EXPORT_SUCCEEDED,
        payload: response
    };
}

export function failedExportReportsHarvestInspectionsAll(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_EXPORT_FAILED,
        payload: error,
        error: true
    };
}

export function setReportsHarvestInspectionsAll(data: Record<string, any>[]) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_SET,
        payload: data,
        meta: {
            // TODO create meaningful composite key
            keyBy: 'todo'
        }
    };
}

export function mergeReportsHarvestInspectionsAll(data: Record<string, any>[]) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGE,
        payload: data
    };
}

export function setReportsHarvestInspection(data: Record<string, any>) {
    return {
        type: REPORTS_HARVEST_INSPECTION_SET,
        payload: data
    };
}
